const getQueryParams = function getQueryParams(qs) {
  qs = qs.split("+").join(" ");
  var params = {},
    tokens,
    re = /[?&]?([^=]+)=([^&]*)/g;
  while (tokens = re.exec(qs)) {
    params[decodeURIComponent(tokens[1])] = decodeURIComponent(tokens[2]);
  }
  return params;
};
const domReady = function (fn, context) {
  function onReady(event) {
    document.removeEventListener("DOMContentLoaded", onReady);
    fn.call(context, event);
  }
  function onReadyIe(event) {
    if (document.readyState === "complete") {
      document.detachEvent("onreadystatechange", onReadyIe);
      fn.call(context, event);
    }
  }
  document.addEventListener && document.addEventListener("DOMContentLoaded", onReady) || document.attachEvent && document.attachEvent("onreadystatechange", onReadyIe);
};
const on = function (event, elem, callback, capture) {
  if (typeof elem === "function") {
    capture = callback;
    callback = elem;
    elem = window;
  }
  capture = capture ? true : false;
  elem = typeof elem === "string" ? document.querySelector(elem) : elem;
  if (!elem) return;
  elem.addEventListener(event, callback, capture);
};
const parents = function (elem, selector) {
  var elements = [];
  var ishaveselector = selector !== undefined;
  while ((elem = elem.parentElement) !== null) {
    if (elem.nodeType !== Node.ELEMENT_NODE) {
      continue;
    }
    if (!ishaveselector || elem.matches(selector)) {
      elements.push(elem);
    }
  }
  return elements;
};
export { getQueryParams, domReady, on, parents };